/**
 * Training Service Module
 * 
 * Provides API functions for managing training data including CRUD operations.
 * Handles training records, completion status, and score updates.
 * 
 * @module TrainingService
 */
import axios from "axios";

// Configure API URL based on environment
let MASTER_API_URL
if (process.env.REACT_APP_NODE_ENV === "local") {
   MASTER_API_URL = process.env.REACT_APP_TRAINING_API_URL;
}
else{
  MASTER_API_URL = process.env.REACT_APP_API_URL + "training";
}

/**
 * Retrieves all training records by type
 * 
 * @async
 * @function getAllTraining
 * @param {string} type - The type of training to retrieve (e.g., 'active', 'completed')
 * @returns {Promise<Object>} Response data containing training records
 * @throws {Object} Returns error object with message and status on failure
 * 
 * @example
 * const activeTrainings = await getAllTraining('active');
 */
export async function getAllTraining(type) {
    const response = await axios
      .get(MASTER_API_URL + `/get/${type}`)
      .then(function (resp) {
        return resp;
      })
      .catch(function (error) {
        return { message: "Unable to find request", status: false };
      });
    return response.data;
  }


  export async function getAllTrainingss() {

    const response = await axios
      .get(MASTER_API_URL + `/getAllTrainings`)
      .then(function (resp) {
        return resp;
      })
      .catch(function (error) {
        return { message: "Unable to find request", status: false };
      });
    return response.data;
  }

/**
 * Retrieves all completed training records
 * 
 * @async
 * @function getCompletedTraining
 * @returns {Promise<Object>} Response data containing completed training records
 * @throws {Object} Returns error object with message and status on failure
 * 
 * @example
 * const completedTrainings = await getCompletedTraining();
 */
export async function getCompletedTraining() {
    const response = await axios
      .get(MASTER_API_URL + "/get/Completed")
      .then(function (resp) {
        return resp;
      })
      .catch(function (error) {
        return { message: "Unable to find request", status: false };
      });
    return response.data;
  }
/**
 * Creates a new training record
 * 
 * @async
 * @function AddNewTraining
 * @param {Object} training - Training object containing all required fields
 * @param {string} training.wld_trainingSub - Training subject
 * @param {string} training.wld_fromDate - Start date
 * @param {string} training.wld_toDate - End date
 * @param {string} training.wld_faculty - Faculty name
 * @returns {Promise<Object>} Response data with creation status
 * @throws {Object} Returns error object with message and status on failure
 * 
 * @example
 * const newTraining = {
 *   wld_trainingSub: 'Welding Basics',
 *   wld_fromDate: '2024-01-01',
 *   wld_toDate: '2024-01-05',
 *   wld_faculty: 'John Doe'
 * };
 * const result = await AddNewTraining(newTraining);
 */
export const AddNewTraining = async (training) => {
    let url = `${MASTER_API_URL}/post`;
    const response = await axios
      .post(url, training)
      .then(function (resp) {
        return resp;
      })
      .catch(function (error) {
        return { message: "Unable to find request", status: false };
      });
    return response.data;
  };

/**
 * Updates an existing training record
 * 
 * @async
 * @function UpdateTraining
 * @param {Object} training - Training object with updated fields
 * @param {string} training.SK - Unique identifier for the training record
 * @param {string} [training.wld_trainingSub] - Updated training subject
 * @param {string} [training.wld_fromDate] - Updated start date
 * @param {string} [training.wld_toDate] - Updated end date
 * @param {string} [training.wld_faculty] - Updated faculty name
 * @returns {Promise<Object>} Response data with update status
 * @throws {Object} Returns error object with message and status on failure
 * 
 * @example
 * const updatedTraining = {
 *   SK: 'training-123',
 *   wld_trainingSub: 'Advanced Welding'
 * };
 * const result = await UpdateTraining(updatedTraining);
 */
export const UpdateTraining = async (training) => {
    let url = `${MASTER_API_URL}/update/${training.SK}`;

    const response = await axios
        .post(url, training)
        .then(function (resp) {
        return resp;
        })
        .catch(function (error) {
        return { message: "Unable to find request", status: false };
        });
    return response.data;
};

/* export const updateTrainingScore = async (training) => {
  let url = `${MASTER_API_URL}/updatescore`;

  const response = await axios
      .post(url, training)
      .then(function (resp) {
      return resp;
      })
      .catch(function (error) {
      return { message: "Unable to find request", status: false };
      });
  return response.data;
};  */

/**
 * Deletes a training record
 * 
 * @async
 * @function DeleteTraining
 * @param {Object} training - Training object to delete
 * @param {string} training.SK - Unique identifier for the training record
 * @returns {Promise<Object>} Response object with deletion status
 * @throws {string} Returns error message on failure
 * 
 * @example
 * const trainingToDelete = { SK: 'training-123' };
 * const result = await DeleteTraining(trainingToDelete);
 */
export const DeleteTraining = async (training) => {
  let url = `${MASTER_API_URL}/delete`;
  const resp = await axios
    .post(url,training)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}